// extracted by mini-css-extract-plugin
export default {"cls1":"VerticalSpacer-cls1__b7d86bcf5bf0c62f0069","cls2":"VerticalSpacer-cls2___1e3c4931c6297665a7f VerticalSpacer-cls1__b7d86bcf5bf0c62f0069"};